import { useEffect } from 'react';
import { useBotProfile } from '@/lib/hooks';

/**
 * Browser tab = the bot: its name as title, its avatar as favicon (live from
 * Discord via useBotProfile). Mounted once at the root, also on the login page.
 */
export function BrandHead() {
  const { data } = useBotProfile();

  useEffect(() => {
    if (!data) return;
    document.title = data.name;
    if (data.avatarUrl) {
      let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = data.avatarUrl;
    }
  }, [data]);

  return null;
}
